// extracted by mini-css-extract-plugin
export var actionButton = "_di-0";
export var fileInput = "_di-2";
export var paperclip = "_di-1";